import { render, staticRenderFns } from "./ReportHistoryPatrimony.vue?vue&type=template&id=2564b476&"
import script from "./ReportHistoryPatrimony.vue?vue&type=script&lang=js&"
export * from "./ReportHistoryPatrimony.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports